export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      products: "Ürünler",
      media: "Medya",
      quote: "Teklif Al",
      contact: "İletişim",
    },
    hero: {
      slides: [
        { overline: "GÜCÜNÜZE GÜÇ KATMAK", title: "Bizim İşimiz!", cta: "Ürünleri Keşfet" },
        { overline: "GELECEĞİN TARIM MAKİNELERİ", title: "Bugünden Burada!", cta: "Teklif Al" },
        { overline: "GÜVENLE GELECEĞİNİZİ", title: "Koruyoruz!", cta: "Hakkımızda" },
      ],
    },
    about: {
      overline: "MESTAR'I TANIYINIZ",
      title: "Tarımda Gücünüz",
      description: "Patates ve soğan hasat makineleri sektöründe Konya'nın önde gelen üreticilerinden olan Mestar, modern ve sürdürülebilir tarım uygulamalarını destekleyen yüksek kaliteli ekipmanlar üretmektedir. HARDOX kalitesinde bıçaklar, ısıl işlem görmüş ithal kalite paletler ve dayanıklı özellikleriyle ürünlerimiz, zorlu toprak koşullarında bile uzun ömürlü ve güvenilir performans sunar.",
      vision: "Vizyon & Misyon",
      visionText: "Daha iyisini hedefledik, en iyisini ürettik. Tarım makineleri sektöründe dünya standartlarında ürünler sunarak çiftçilerimizin verimliliğini artırmayı hedefliyoruz.",
      readMore: "Devamını Oku",
    },
    stats: {
      products: "ÜRÜN ÇEŞİDİ",
      experience: "YILLIK TECRÜBE",
      countries: "İHRACAT ÜLKESİ",
      employees: "ÇALIŞAN",
    },
    products: {
      overline: "ÜRÜN YELPAZEMIZ",
      title: "Makinelerimiz",
      viewAll: "Tüm Ürünler",
      explore: "Keşfet",
      categories: {
        "soil-preparation": { name: "Toprak Hazırlama Ekipmanları", desc: "Ekim öncesi toprak hazırlama makineleri" },
        "potato-planters": { name: "Patates Dikim Ekipmanları ", desc: "Tam ve yarı otomatik dikim makineleri" },
        "potato-harvesters": { name: "Patates Söküm Ekipmanları", desc: "Paletli patates söküm makineleri" },
        "onion-harvesters": { name: "Soğan Söküm Ekipmanları", desc: "Profesyonel soğan hasat çözümleri" },
      },
    },
    productDetail: {
      specs: "Teknik Özellikler",
      features: "Öne Çıkan Özellikler",
      getQuote: "Bu Ürün İçin Teklif Al",
      back: "Ürünlere Dön",
      workingWidth: "Çalışma Genişliği",
      rows: "Sıra Sayısı",
      rowSpacing: "Sıra Aralığı",
      tractorPower: "Traktör Gücü",
      workingCapacity: "Çalışma Kapasitesi",
      weight: "Ağırlık",
      workingDepth: "Çalışma Derinliği",
      hopperCapacity: "Hazne Kapasitesi",
      bladeCount: "Bıçak Sayısı",
      sievingArea: "Eleme Alanı",
      spacingAboveRows: "Sıra Üstü Aralık",
      fertilizerCapacity: "Gübre Hazne Kapasitesi",
    },
    media: {
      overline: "BİZDEN İÇERİKLER",
      title: "Haberler & Medya",
      news: "Haber İçeriklerimiz",
      photos: "Fotoğraf İçeriklerimiz",
      videos: "Video İçeriklerimiz",
      viewAll: "Medya",
    },
    quote: {
      overline: "BİZİMLE İLETİŞİME GEÇİN",
      title: "Teklif Al",
      name: "Adınız Soyadınız",
      email: "E-posta Adresiniz",
      phone: "Telefon Numaranız",
      company: "Firma Adı (Opsiyonel)",
      productInterest: "İlgilendiğiniz Ürün",
      message: "Mesajınız",
      send: "Teklif Talebi Gönder",
      success: "Teklif talebiniz başarıyla gönderildi!",
      selectProduct: "Ürün Seçiniz",
    },
    footer: {
      tagline: "Daha iyisini hedefledik, en iyisini ürettik.",
      quickLinks: "Hızlı Bağlantılar",
      contactInfo: "İletişim Bilgileri",
      address: "Fevzi Çakmak Mah. Sıla Cad. No: 16 Karatay/KONYA",
      rights: "Tüm Hakları Saklıdır.",
    },
    marquee: "Daha iyisini hedefledik, en iyisini ürettik",
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      media: "Media",
      quote: "Get a Quote",
      contact: "Contact",
    },
    hero: {
      slides: [
        { overline: "ADDING POWER TO YOUR STRENGTH", title: "That's Our Business!", cta: "Explore Products" },
        { overline: "FUTURE AGRICULTURAL MACHINES", title: "Are Here Today!", cta: "Get a Quote" },
        { overline: "CONFIDENTLY PROTECTING", title: "Your Future!", cta: "About Us" },
      ],
    },
    about: {
      overline: "MEET MESTAR",
      title: "Your Power in Agriculture",
      description: "As one of Konya's leading manufacturers in the potato and onion harvesting equipment sector, Mestar produces high-quality equipment that supports modern and sustainable farming practices. With HARDOX quality blades, heat-treated imported quality pallets, and durable features, our products deliver long-lasting and reliable performance even in challenging soil conditions.",
      vision: "Vision & Mission",
      visionText: "We aimed for better, and produced the best. We aim to increase the productivity of our farmers by offering world-class products in the agricultural machinery sector.",
      readMore: "Read More",
    },
    stats: {
      products: "PRODUCT TYPES",
      experience: "YEARS EXPERIENCE",
      countries: "EXPORT COUNTRIES",
      employees: "EMPLOYEES",
    },
    products: {
      overline: "OUR PRODUCT RANGE",
      title: "Our Machines",
      viewAll: "All Products",
      explore: "Explore",
      categories: {
        "soil-preparation": { name: "Soil Preparation Equipment", desc: "Pre-planting soil preparation machines" },
        "potato-planters": { name: "Potato Planters Equipment", desc: "Full and semi-automatic planting machines" },
        "potato-harvesters": { name: "Potato Harvesters Equipment", desc: "Pallet potato harvesting machines" },
        "onion-harvesters": { name: "Onion Harvesters Equipment", desc: "Professional onion harvesting solutions" },
      },
    },
    productDetail: {
      specs: "Technical Specifications",
      features: "Key Features",
      getQuote: "Get a Quote for This Product",
      back: "Back to Products",
      workingWidth: "Working Width",
      rows: "Rows",
      rowSpacing: "Row Spacing",
      tractorPower: "Tractor Power",
      workingCapacity: "Working Capacity",
      weight: "Weight",
      workingDepth: "Working Depth",
      hopperCapacity: "Hopper Capacity",
      bladeCount: "Blade Count",
      sievingArea: "Sieving Area",
      spacingAboveRows: "Spacing Above Rows",
      fertilizerCapacity: "Fertilizer Capacity",
    },
    media: {
      overline: "CONTENT FROM US",
      title: "News & Media",
      news: "News Articles",
      photos: "Photo Gallery",
      videos: "Video Content",
      viewAll: "Media",
    },
    quote: {
      overline: "GET IN TOUCH",
      title: "Get a Quote",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      company: "Company Name (Optional)",
      productInterest: "Product of Interest",
      message: "Your Message",
      send: "Send Quote Request",
      success: "Your quote request has been sent successfully!",
      selectProduct: "Select a Product",
    },
    footer: {
      tagline: "We aimed for better, and produced the best.",
      quickLinks: "Quick Links",
      contactInfo: "Contact Information",
      address: "Fevzi Çakmak Mah. Sıla Cad. No: 16 Karatay/KONYA",
      rights: "All Rights Reserved.",
    },
    marquee: "We aimed for better, and produced the best",
  },
  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      products: "المنتجات",
      media: "الوسائط",
      quote: "طلب عرض سعر",
      contact: "اتصل بنا",
    },
    hero: {
      slides: [
        { overline: "نضيف القوة إلى قوتكم", title: "هذا عملنا!", cta: "استكشف المنتجات" },
        { overline: "آلات الزراعة المستقبلية", title: "موجودة اليوم!", cta: "طلب عرض سعر" },
        { overline: "نحمي مستقبلكم", title: "بثقة!", cta: "من نحن" },
      ],
    },
    about: {
      overline: "تعرف على ميستار",
      title: "قوتكم في الزراعة",
      description: "بصفتها واحدة من الشركات الرائدة في قونيا في قطاع معدات حصاد البطاطس والبصل، تنتج ميستار معدات عالية الجودة تدعم ممارسات الزراعة الحديثة والمستدامة. مع شفرات بجودة HARDOX ومنصات مستوردة معالجة حرارياً وميزات متينة، تقدم منتجاتنا أداءً موثوقاً وطويل الأمد حتى في ظروف التربة الصعبة.",
      vision: "الرؤية والرسالة",
      visionText: "هدفنا الأفضل، وأنتجنا الأفضل. نهدف إلى زيادة إنتاجية مزارعينا من خلال تقديم منتجات عالمية المستوى في قطاع الآلات الزراعية.",
      readMore: "اقرأ المزيد",
    },
    stats: {
      products: "أنواع المنتجات",
      experience: "سنوات الخبرة",
      countries: "دول التصدير",
      employees: "الموظفين",
    },
    products: {
      overline: "مجموعة منتجاتنا",
      title: "آلاتنا",
      viewAll: "جميع المنتجات",
      explore: "استكشف",
      categories: {
        "soil-preparation": { name: "معدات تحضير التربة", desc: "آلات تحضير التربة قبل الزراعة" },
        "potato-planters": { name: "آلات زراعة البطاطس", desc: "آلات زراعة أوتوماتيكية وشبه أوتوماتيكية" },
        "potato-harvesters": { name: "آلات حصاد البطاطس", desc: "آلات حصاد البطاطس بالمنصات" },
        "onion-harvesters": { name: "آلات حصاد البصل", desc: "حلول حصاد البصل المهنية" },
      },
    },
    productDetail: {
      specs: "المواصفات الفنية",
      features: "الميزات الرئيسية",
      getQuote: "طلب عرض سعر لهذا المنتج",
      back: "العودة إلى المنتجات",
      workingWidth: "عرض العمل",
      rows: "عدد الصفوف",
      rowSpacing: "تباعد الصفوف",
      tractorPower: "قوة الجرار",
      workingCapacity: "سعة العمل",
      weight: "الوزن",
      workingDepth: "عمق العمل",
      hopperCapacity: "سعة القادوس",
      bladeCount: "عدد الشفرات",
      sievingArea: "مساحة الغربلة",
      spacingAboveRows: "التباعد فوق الصفوف",
      fertilizerCapacity: "سعة الأسمدة",
    },
    media: {
      overline: "محتوى منا",
      title: "الأخبار والوسائط",
      news: "مقالاتنا الإخبارية",
      photos: "معرض الصور",
      videos: "محتوى الفيديو",
      viewAll: "الوسائط",
    },
    quote: {
      overline: "تواصل معنا",
      title: "طلب عرض سعر",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      company: "اسم الشركة (اختياري)",
      productInterest: "المنتج المطلوب",
      message: "رسالتك",
      send: "إرسال طلب العرض",
      success: "تم إرسال طلب العرض بنجاح!",
      selectProduct: "اختر منتجاً",
    },
    footer: {
      tagline: "هدفنا الأفضل، وأنتجنا الأفضل.",
      quickLinks: "روابط سريعة",
      contactInfo: "معلومات الاتصال",
      address: "Fevzi Çakmak Mah. Sıla Cad. No: 16 Karatay/KONYA",
      rights: "جميع الحقوق محفوظة.",
    },
    marquee: "هدفنا الأفضل وأنتجنا الأفضل",
  },
};
